import React from 'react';
import PropTypes from 'prop-types';

import NavLink from '../../global/NavLink';

import {
  Wrapper,
  Products,
  Product,
  Link,
  Links,
  Name,
  CatLink,
  MobileCatLink,
  Mobile
} from './components';
import ColorMask from '../../global/ColorMask';
import H1 from '../../global/typography/H1';

const TO = 'products';

const ProductCategories = ({ productCategories }) => (
  <Wrapper>
    <H1>Products</H1>
    <Products>
      {productCategories.filter((category) => category.enabled).map(({ classes, id, name, slug }) => {
        const { image } = classes[0];
        return (
          <Product key={id}>
            <Link image={`home/${image}`} key={id} to={`${TO}/${slug}`}>
              <ColorMask />
            </Link>
            <Mobile>
              <Name>{name.replace('and', '&')}</Name>
              <Links>
                {classes.length > 1 &&
                  classes.map((sub, idx) => (
                    <NavLink to={`${TO}/${sub.slug}`} key={sub.id}>
                      <MobileCatLink>
                        {`${sub.name
                          .replace(name, '')
                          .replace('Pool Heaters', '')
                          .trim()}`}
                      </MobileCatLink>
                      <CatLink>
                        {`${sub.name
                          .replace(name, '')
                          .replace('Pool Heaters', '')
                          .trim()}`}
                      </CatLink>
                      &nbsp;
                    </NavLink>
                  ))}
                <NavLink to={`${TO}/${slug}`} key={id}>
                  <MobileCatLink>View All</MobileCatLink>
                  <CatLink>View All</CatLink>
                </NavLink>
              </Links>
            </Mobile>
          </Product>
        );
      })}
    </Products>
  </Wrapper>
);

ProductCategories.propTypes = {
  productCategories: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ProductCategories;
